const Z_INDEX = {
  DRAG_IMAGE_ELEMENT: -1,

  STICKY_SHADOW: 90,

  TABLE_VIEW_INSERT_DOT: 127,

  // we want row select button to be higher than the row drop indicator
  ROW_SELECT_BUTTON: 116,
  TABLE_VIEW_ROW_DROP_INDICATOR: 115,

  TABLE_RESIZE_HANDLER: 130,

  TABLE_VIEW_SELECTION_TOOLBAR: 133,

  TABLE_VIEW_DROP_INDICATOR: 135,
  COLUMN_SELECT_BUTTON: 140,

  /** Inline dialogs (Popups that may contain dropdowns and selects and may be used in dialogs) */
  INLINE_DIALOG: 510,

  /** Color picker (can be opened from inside a Select) */
  COLOR_PICKER: 760,

  /* Tooltip (used for Popups that act as a tooltip) */
  TOOLTIP: 800,
};

export default Z_INDEX;
